import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {
    display: 'flex',
    marginTop: '24px',
    justifyContent: 'flex-end',
  },
  pagination: {
    width: '100%',
    maxWidth: '272px',
    display: 'flex',
    marginRight: '-19px' /* pagination needs to be flush and icons are SVG */,
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  pages: {
    width: '100%',
    margin: '0px',
    padding: '0px',
    listStyle: 'none',
    display: 'flex',
    justifyContent: 'space-around',
    cursor: 'pointer',
    '& > li': {
      width: '28px',
      height: '24px',
      margin: '8px 0px 0px 0px',
      padding: '0px',
      textAlign: 'center',
      color: `${theme.colors.eyConfidentGrey}`,
    },
    '& > li:hover': {
      borderBottom: `solid 3px ${theme.colors.eyConfidentGrey}`,
    },
  },
  pageActive: {
    borderBottom: `solid 3px ${theme.colors.eyConfidentGrey}`,
  },
  actionArrow: {
    height: '30px',
    width: '30px',
    color: `${theme.colors.eyGrey8}`,
  },
});

class TablePagination extends React.Component {
  static propTypes = {
    /** Styles to be applied to component */
    classes: PropTypes.object,
    /** If provided, the total number of rows per page */
    rowsPerPage: PropTypes.number,
    /** Callback function for page changes */
    onPageChange: PropTypes.func,
  };

  getPages = (currentPage, totalPages) => {
    let leftPages = [];
    let rightPages = [];
    let pagesAdded = 0;

    for (let iterationCount = 1; pagesAdded < 4 && iterationCount <= totalPages; iterationCount++) {
      const leftCheck = currentPage - iterationCount;
      const rightCheck = currentPage + iterationCount;

      if (leftCheck > 0) {
        leftPages.unshift(leftCheck);
        pagesAdded++;
      }

      if (rightCheck <= totalPages) {
        rightPages.push(rightCheck);
        pagesAdded++;
      }
    }

    const pages = [...leftPages, currentPage, ...rightPages];
    return pages;
  };

  render() {
    const { classes, page, rowsPerPage, rowCount, onChangePage } = this.props;

    const currentPage = page + 1;
    const totalPages = Math.ceil(rowCount / rowsPerPage);
    const pages = this.getPages(currentPage, totalPages);

    return (
      <div className={classes.root}>
        <div className={classes.pagination}>
          <IconButton disabled={currentPage <= 1} onClick={onChangePage.bind(null, page - 1)}>
            <KeyboardArrowLeft className={classes.actionArrow} />
          </IconButton>
          <ul className={classes.pages}>
            {pages.map(pageNumber => {
              const pageClass = classNames({ [classes.pageActive]: currentPage === pageNumber });
              return (
                <li key={pageNumber} onClick={onChangePage.bind(null, pageNumber - 1)} className={pageClass}>
                  {pageNumber}
                </li>
              );
            })}
          </ul>
          <IconButton disabled={currentPage >= totalPages} onClick={onChangePage.bind(null, page + 1)}>
            <KeyboardArrowRight className={classes.actionArrow} />
          </IconButton>
        </div>
      </div>
    );
  }
}

export default styled(TablePagination)(styles);
